import { ErrorType } from '@/utilities/errors/types';

import { APIServiceType, CustomerDataEndpoint } from '../types';
import customerDataRequest from './fetch-customer-data';

import { CustomError } from '@/utilities/errors/CustomError';
import { CustomerDataSlice } from '@/store/slices/customerData/types';
import { setCustomerDataError } from '@/store/actions';

/**
 * Pure fetch + error mapping. Customer `loading` is driven by {@link useCustomerData}
 * from TanStack Query so cache/hydration/refetch-cancel paths never leave loading stuck
 * when this function does not run to completion.
 */
export const fetchCustomerFeatures = async (
  queryParams: Record<string, unknown> = {},
): Promise<CustomerDataSlice['customerData']> => {
  try {
    const data = await customerDataRequest(
      CustomerDataEndpoint.FEATURES,
      queryParams,
    );

    return data;
  } catch (error) {
    setCustomerDataError({
      type: 'CUSTOMER_FEATURES',
      details: {
        ...(error as object),
      },
    });

    throw new CustomError('[GW][FETCH_CUSTOMER_FEATURES] Failed', {
      type: ErrorType.API,
      reason: 'Error fetching customer features',
      service: APIServiceType.CUSTOMER_DATA,
      stack: error instanceof Error ? error.stack : undefined,
      context: {
        error: error instanceof Error ? error.name : 'Unknown error',
      },
    });
  }
};
